import React from "react";

function PageHeader({ pageTitle, description, customize }) {
  return (
    <div className="w-full relative">
      <svg
        className={`w-full h-[155px]  fill-none absolute -top-2 
          ${customize === "academics" ? "md:h-[312px]" : "md:h-[234.5px]"}`}
        viewBox="0 0 375 155"
        preserveAspectRatio="none"
      >
        <path
          d="M0 0H375C375 0 375 78.9715 375 122.133C375 165.294 -2.17998e-06 166.613 0 122.133C2.17998e-06 77.6522 0 0 0 0Z"
          fill="url(#paint0_linear_400_2874)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_400_2874"
            x1="187.5"
            y1="0"
            x2="187.5"
            y2="155"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FDE5EF" />
            <stop offset="1" stopColor="#EDB6CD" />
          </linearGradient>
        </defs>
      </svg>
      <div className=" h-[155px] md:h-[230px] flex flex-col items-center justify-center md:gap-y-10 gap-y-4 responsive-padding">
        <h1
          className="font-montserrat font-extrabold md:text-[50px] text-2xl leading-4 tracking-[0.04em] text-text-dark  z-40 text-nowrap"
          style={{ textShadow: "0 4px 4px rgba(0, 0, 0, 0.25)" }}
        >
          {pageTitle}
        </h1>
        <p className="md:w-[450px] font-notoSans font-light md:text-sm text-xs leading-5 tracking-[0.04em] text-center text-grey-normal  z-40">
          {description}
        </p>
      </div>
    </div>
  );
}

export default PageHeader;
